export { StructuredDataWidget } from './StructuredDataWidget';
